export const getEventTypesFromAPI = (types: string) => {
  return types.split('-').map((type) => type.toLowerCase())
}
